import { observable, action, makeObservable } from "mobx";
import axios from 'axios';
class layoutStore {
    showToast = false;
    toastData = {}
    isLoggedIn = window.localStorage.getItem("4r7ur2") ? true : false;

    constructor() {
        makeObservable(this, {
            isLoggedIn: observable,
            showToast: observable,
            toastData: observable,
            showToaster: action,
            initiateLogin: action,
            userLogout: action,
            checkResetLink: action,
            resetPassword: action,
            sendResetLink: action,
        });
    }
    initiateLogin = async (email, password) => {
        const resp = await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/login`, {
            email,
            password,
            role: "admin"
        });
        if (resp.data.error) {
            return resp.data;
        }
        else {
            window.localStorage.setItem("4r7ur2", resp.data.token);
            window.localStorage.setItem("4r7ur-name", resp.data.user.name);
            window.localStorage.setItem("4r7ur-title", resp.data.user.title);
            window.localStorage.setItem("4r7ur-company", resp.data.user.companyName);
            window.localStorage.setItem("showOnboarding", resp.data.onboarding)
            this.isLoggedIn = true;
            setTimeout(() => {
                window.location.reload(false);
            }, 1000);
            return resp.data;
        }
    }
    
    initiateSignUp = async (data) => {
        const resp = await axios.post( `${process.env.REACT_APP_API_URL}/api/auth/signup`,
            data
        );
        return resp.data;
    };

    userLogout = () => {
        window.localStorage.removeItem("4r7ur2");
        window.localStorage.removeItem("4r7ur-name");
        window.localStorage.removeItem("4r7ur-title");
        window.localStorage.removeItem("4r7ur-company");
        this.isLoggedIn = false;
        setTimeout(() => {
            window.location.reload(false);
        }, 1000);
    }

    checkResetLink = async (token) => {
        const resp = await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/password-token-check`, {
            token
        });
        return resp.data;
    }

    resetPassword = async (token, password) => {
        const resp = await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/password-reset`, {
            token,
            password
        });
        return resp.data;
    }

    sendResetLink = async (email) => {
        const resp = await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/password-reset-link`, {
            email,
            role: "admin"
        });
        return resp.data;
    }

    showToaster = (message, type) => {
        this.showToast = true;
        this.toastData = {
            message,
            type
        }
        setTimeout(() => {
            this.showToast = false;
        }, 300);
    };
}
export default new layoutStore();